var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Header', {
    attrs: {
      "meta": _vm.meta,
      "page-title": _vm.moduleConfig.page_title,
      "page-image": _vm.moduleConfig.page_image,
      "page-kv-image": _vm.moduleConfig.page_kv_image,
      "header-section": _vm.moduleConfig.header_section
    }
  }), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.displayTitle))]), _c('div', {
    staticClass: "s-edit-section"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [!_vm.croppingImage ? _c('SharedButton', {
    staticClass: "s-btn-bg-primary mb-2 mr-2",
    attrs: {
      "disabled": !_vm.canClick
    },
    on: {
      "click": _vm.openFileSelector
    }
  }, [_vm._v(" 選取照片 ")]) : _vm._e(), !_vm.croppingImage ? _c('SharedButton', {
    staticClass: "s-btn-bg-primary mb-2 mr-2",
    attrs: {
      "disabled": !_vm.canClick
    },
    on: {
      "click": _vm.openCameraSelector
    }
  }, [_vm._v(" 拍照上傳 ")]) : _vm._e(), !_vm.croppingImage ? _c('SharedButton', {
    staticClass: "s-btn-bg-primary mb-2",
    on: {
      "click": function click() {
        return _vm.openWebCam = true;
      }
    }
  }, [_vm._v(" 立即拍照 ")]) : _vm._e(), _vm.openWebCam ? _c('WebCamDialog', {
    attrs: {
      "title": "圖片加框框",
      "reminder": {
        title: '秘訣',
        text: '挑選一張你最愛的度假風照片上傳或開啟相機來自拍吧！打造如同 GUCCI LIDO 形象廣告裡所營造徜徉水中自在快樂地氛圍。'
      },
      "maskImage": _vm.selectedMask
    },
    on: {
      "close": function close() {
        return _vm.openWebCam = false;
      },
      "snap": function snap(imageBase64) {
        return _vm.loadImageWebCam(imageBase64);
      }
    }
  }) : _vm._e()], 1), _vm.croppingImage ? _c('SharedButton', {
    staticClass: "s-btn-bg-secondary mb-2",
    attrs: {
      "disabled": !_vm.canClick
    },
    on: {
      "click": _vm.resetCropping
    }
  }, [_vm._v(" 取消 ")]) : _vm._e(), _vm.croppingImage ? _c('SharedButton', {
    staticClass: "s-btn-bg-primary mb-2",
    attrs: {
      "disabled": !_vm.canClick
    },
    on: {
      "click": _vm.cropImage
    }
  }, [_vm._v(" 裁切 ")]) : _vm._e()], 1), _vm.croppingImage ? _c('div', {
    staticClass: "s-edit-section-cropper",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('VueCropper', {
    ref: "cropper",
    staticClass: "sr-only",
    attrs: {
      "src": _vm.croppingImage,
      "aspect-ratio": _vm.aspectRatio,
      "initialAspectRatio": _vm.aspectRatio
    }
  }), _vm.croppingImage ? _c('img', {
    attrs: {
      "id": _vm.randomId,
      "src": _vm.croppingImage
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.displayImage ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.displayImage
    }
  })]) : _vm._e()]), _c('input', {
    ref: "input",
    staticClass: "s-file-input",
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "image/*",
      "multiple": false
    },
    on: {
      "change": _vm.loadImage
    }
  }), _c('input', {
    ref: "camera",
    staticClass: "s-file-input",
    attrs: {
      "type": "file",
      "capture": "environment",
      "accept": "image/*",
      "multiple": false
    },
    on: {
      "change": _vm.loadImage
    }
  })])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }